import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Desktop_VerticalSlider({ imgArray, mainImage, setMainImage }) {
    const verticalSliderSettings = { dots: false, infinite: false, slidesToShow: 6, slidesToScroll: 1, vertical: true, verticalSwiping: true };

    return (
        <Slider {...verticalSliderSettings} className="productVerticalSlider">
            {imgArray.map((currentImg, index) => (
                <div key={index} className={`imgThumb border-[2px] p-[2px] aspect-[1/1]  cursor-pointer ${mainImage === currentImg ? "border-indigo-500 p-[4px] duration-100" : null}`}>
                    <img src={currentImg} key={index} onMouseEnter={() => setMainImage(currentImg)} alt="" className={`object-cover rounded-sm aspect-[1/1]`} />
                </div>
            ))}
        </Slider>
    );
}

export default Desktop_VerticalSlider;